import { ApiRequestFilters } from '../../../types/api-request-filters';
import { UserRoleEnum } from '../enums/user-role.enum';
import { UserStatusEnum } from '../enums/user-status.enum';
import { UserTypeEnum } from '../enums/user-type.enum';

/**
 * User filters
 */
export class UsersFilters extends ApiRequestFilters {
	/**
	 * User role values
	 */
	roles?: UserRoleEnum[];

	/**
	 * Status values
	 */
	statuses?: UserStatusEnum[];

	/**
	 * User type values
	 */
	types?: UserTypeEnum[];
}
